import { render, staticRenderFns } from "./QuoteServiceVariableListPage.vue?vue&type=template&id=35aa00a2&"
import script from "./QuoteServiceVariableListPage.vue?vue&type=script&lang=ts&"
export * from "./QuoteServiceVariableListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports